/* ============================================================
   Formulaires d'inscription — adresse incomplete
   ------------------------------------------------------------
   « nom@domaine » est une adresse valide pour HTML : le navigateur
   laissait partir le formulaire, Shopify la refusait, et rien ne le
   disait. On la juge avant l'envoi, et le message s'ecrit sous le champ,
   dans la langue de la boutique, au lieu de la bulle du navigateur.
   Sans ce script, la validation native reste en place.
   Charge par le pied de page, la banniere et la popup : il ne s'installe
   qu'une fois.
   ============================================================ */
(function () {
  'use strict';
  if (window.lfNewsletter) return;
  window.lfNewsletter = true;

  var CHAMP = 'input[type="email"][name="contact[email]"]';
  // Un « @ », puis un domaine qui porte au moins un point.
  var COMPLETE = /^[^\s@]+@[^\s@.]+(\.[^\s@.]+)+$/;

  function texte(z) {
    return (z && z.getAttribute('data-lf-email-error')) || 'Enter a complete email address.';
  }

  function zone(champ) {
    var ids = (champ.getAttribute('aria-describedby') || '').split(' ');
    for (var i = 0; i < ids.length; i++) {
      var el = ids[i] && document.getElementById(ids[i]);
      if (el && el.hasAttribute('data-lf-email-error')) return el;
    }
    return null;
  }

  function juger(champ) {
    var v = champ.value.trim();
    champ.setCustomValidity(v && !COMPLETE.test(v) ? texte(zone(champ)) : '');
  }

  // Le clic sur le bouton precede la validation du formulaire — y compris
  // celui que declenche la touche Entree : c'est le moment de juger la
  // valeur, meme remplie par le navigateur.
  document.addEventListener('click', function (e) {
    var bouton = e.target.closest && e.target.closest('button, input[type="submit"]');
    var form = bouton && bouton.type === 'submit' && bouton.form;
    var champ = form && form.querySelector(CHAMP);
    if (champ) juger(champ);
  }, true);

  document.addEventListener('invalid', function (e) {
    var champ = e.target;
    if (!champ.matches || !champ.matches(CHAMP)) return;
    var z = zone(champ);
    if (!z) return;
    e.preventDefault();
    champ.setAttribute('aria-invalid', 'true');
    // Vider puis reecrire : un message identique serait sinon tu.
    z.textContent = '';
    z.textContent = texte(z);
    champ.focus();
  }, true);

  document.addEventListener('input', function (e) {
    var champ = e.target;
    if (!champ.matches || !champ.matches(CHAMP)) return;
    champ.setCustomValidity('');
    if (champ.getAttribute('aria-invalid') === 'true') {
      champ.removeAttribute('aria-invalid');
      var z = zone(champ);
      if (z) z.textContent = '';
    }
  }, true);
})();
